module.exports = __webpack_public_path__ + "919a67dc6a384a0ea879d64469a32417.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/sports/hockey.png
// module id = 1089
// module chunks = 0